import { render, staticRenderFns } from "./RadioReadOnly.vue?vue&type=template&id=2f72e5e9&"
import script from "./RadioReadOnly.vue?vue&type=script&lang=js&"
export * from "./RadioReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f72e5e9')) {
      api.createRecord('2f72e5e9', component.options)
    } else {
      api.reload('2f72e5e9', component.options)
    }
    module.hot.accept("./RadioReadOnly.vue?vue&type=template&id=2f72e5e9&", function () {
      api.rerender('2f72e5e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/radio/RadioReadOnly.vue"
export default component.exports